import type {FC} from 'react';
import clsx from 'clsx';

import {SearchIcon} from '@/components/icons/search';

export const searchInputClasses = clsx(
	'inline-flex',
	'h-12',
	'pr-8',
	'pl-14',
	'bg-transparent',
	'text-bodyMedium',
	'outline-none',
	'rounded-xl',
	'focus:rounded-2xl',
	'hover:rounded-2xl',
	'w-full',
	'border-forestGreen-700',
	'focus:border-forestGreen-700',
	'focus:ring-forestGreen-700',
	'focus:ring-2',
	'focus:outline-none',
	'focus:ring-offset-2',
	'placeholder:text-[#527A76]',
	'transition-all',
	'duration-200',
);

export const SearchInputPrefix: FC = () => {
	return (
		<div
			className={clsx(
				'absolute',
				'h-full',
				'aspect-square',
				'p-3',
				'top-0',
				'left-2',
			)}
		>
			<SearchIcon aria-hidden="true" />
		</div>
	);
};
